<script>

import {
		connected,
		selectedAccount,
		defaultChainStore,
	} from "svelte-web3";

async function makeConnection() {
	await defaultChainStore.setProvider();
}

// $:  {makeConnection()}

</script>

<main>
    <div>
		<nav class="navbar navbar-expand navbar-dark bg-primary">
			<div class="container-fluid">
				<a class="navbar-brand" href="/#">LTT Exchange</a>
					<ul class="navbar-nav">
						<li class="nav-item">
							{#if $connected}
								<a
									class="nav-link small external truncate"
									target="blank"
									href="http://rinkeby.etherscan.io/address/{$selectedAccount}/"
									>{$selectedAccount}</a
								>
							{/if}
						</li>
						<li class="nav-item">
							{#if !$connected}
								<button
									class="btn btn-dark"
									on:click={async () => {
										makeConnection();
									}}>Connect</button
								>
							{/if}
						</li>
					</ul>
			</div>
		</nav>
	</div>
</main>
<style>
	@media only screen and (max-width: 500px) {
  		.truncate {
    	width: 50vw;
  		}
	}
	.truncate{
		white-space: nowrap;
  		overflow: hidden;
  		text-overflow: ellipsis;
	}
</style>